import React, { useRef, useEffect, useState } from 'react';
import aboute_1 from '../../Assets/images/home/aboute-1.png';
import aboute_2 from '../../Assets/images/home/about-2.png';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import {
  motionVariantsTop,
  motionVariantsLeft,
  motionVariantsRight,
  motionProperties,
  motionVariantsBounceOut,
  motionVariantsScaleUp,
  motionVariantsScaleDown
} from '../../Components/Common/MotionVarients';
import CountUpComponent from '../Common/CountUpComponent';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();
  const navigaet = useNavigate()

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after the component becomes visible
        }
      },
      { threshold: 0.1 } // Trigger when at least 10% of the component is visible
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className="lg:px-20 md:px-10 px-5 py-10 overflow-x-hidden" ref={ref}>
      <div className="text-center">
        <motion.h1
          variants={motionVariantsBounceOut}
          {...motionProperties}
          className="md:text-5xl text-3xl font-bold tracking-wider"
        >
          About <span className="text-primaryOrangeColor">TECH</span>
          <span>MENTEE</span>
        </motion.h1>
        <motion.p
          variants={motionVariantsScaleUp}
          {...motionProperties}
          className="md:w-[70%] w-[90%] mx-auto text-secondaryTextColor mt-4 tracking-wider"
        >
          Techmentee, headquartered in Alpharetta, Georgia, is a leading
          multinational IT Consulting company that has successfully served the business community for over five years onshore and over ten years offshore. Since its incorporation, Techmentee has provided a
          wide variety of excellent customized IT solutions to its customers
          on time and on budget. Techmentee has proven itself as an industry leader.
        </motion.p>
      </div>

      <div className="flex flex-col lg:flex-row items-center lg:items-stretch mt-8 gap-6 lg:gap-0">
        <div className="lg:w-[40%] w-full overflow-hidden hidden lg:block">
          <motion.img
            variants={motionVariantsLeft}
            {...motionProperties}
            src={aboute_2}
            alt="image"
            className="w-full h-full object-cover"
          />
        </div>

        <div className='lg:w-[20%] w-full flex items-center justify-center'>
          <div className=" text-center flex flex-col justify-between xl:gap-10 gap-6">
            <div>
              <h1 className="text-2xl font-bold">{isVisible && <CountUpComponent targetValue={90} />}%</h1>
              <p className="text-secondaryTextColor">Success Ratio</p>
            </div>
            <div>
              <h1 className="text-2xl font-bold">{isVisible && <CountUpComponent targetValue={200} />}+</h1>
              <p className="text-secondaryTextColor">Hiring Partners</p>
            </div>
            <div>
              <h1 className="text-2xl font-bold">{isVisible && <CountUpComponent targetValue={96} />}+</h1>
              <p className="text-secondaryTextColor">Positive Feedback</p>
            </div>
            <motion.div
              variants={motionVariantsScaleDown}
              {...motionProperties}
            >
              <button onClick={() => navigaet('/about/about-techmentee')} className="bg-primaryOrangeColor hover:bg-[#f69a3e] cursor-pointer text-white px-4 py-2 rounded-lg">
                Read More
              </button>
            </motion.div>
          </div>
        </div>

        <div className="lg:w-[40%] w-full overflow-hidden hidden lg:block">
          <motion.img
            variants={motionVariantsRight}
            {...motionProperties}
            src={aboute_1}
            alt="image"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
